module.exports = __webpack_public_path__ + "static/media/bjackson.76130b48.jpg";